import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "../http/requestConfig";

export default class EnergyService {
    
    getAll(sCallBack, eCallBack) {
        exeRequest(ApiRoutes.energyResource, {}, sCallBack, eCallBack)
    }
}